import { useScrollReveal } from '@/hooks/useScrollReveal';

const cards = [
  {
    title: '深渊之触',
    category: '奇幻冒险',
    status: '连载中',
    chapters: '更新至 187 话',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20style%20illustration%2C%20deep%20ocean%20abyss%20with%20mysterious%20flowing%20forms%2C%20dramatic%20crimson%20and%20onyx%20color%20palette%2C%20atmospheric%20underwater%20scene%20with%20bioluminescent%20accents%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=card-01&orientation=portrait',
    desc: '深海探险队意外唤醒远古触手生物，一场关乎人类存亡的冒险就此展开。',
    hot: true,
  },
  {
    title: '触手纪元',
    category: '科幻异种',
    status: '已完结',
    chapters: '全 312 话',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20manga%20cover%20with%20alien%20organic%20forms%2C%20dark%20metallic%20tones%20with%20crimson%20highlights%2C%20cyberpunk%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20minimal%20background%2C%20no%20text&width=600&height=800&seq=card-02&orientation=portrait',
    desc: '在未来世界，人类与触手外星生物的共生关系彻底改变了文明进程。',
  },
  {
    title: '暗影使徒',
    category: '都市传说',
    status: '连载中',
    chapters: '更新至 95 话',
    image: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20manga%20cover%2C%20dark%20city%20alley%20with%20mysterious%20shadow%20figures%2C%20crimson%20and%20charcoal%20color%20scheme%2C%20noir%20atmosphere%2C%20dramatic%20contrast%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=card-03&orientation=portrait',
    desc: '普通高中生偶然获得操控暗影触手的能力，卷入超自然世界的纷争。',
  },
  {
    title: '异种学院',
    category: '校园奇幻',
    status: '连载中',
    chapters: '更新至 203 话',
    image: 'https://readdy.ai/api/search-image?query=Academy-themed%20manga%20cover%20with%20supernatural%20elements%2C%20dark%20academic%20setting%20with%20organic%20forms%2C%20deep%20red%20and%20black%20palette%2C%20mysterious%20atmosphere%2C%20clean%20background%2C%20no%20text&width=600&height=800&seq=card-04&orientation=portrait',
    desc: '一所隐藏在世界阴影中的学院，培养与异种生物共存的特殊人才。',
    hot: true,
  },
  {
    title: '触手猎人',
    category: '热血战斗',
    status: '已完结',
    chapters: '全 256 话',
    image: 'https://readdy.ai/api/search-image?query=Action%20manga%20cover%20with%20dynamic%20combat%20scene%2C%20dark%20energy%20and%20crimson%20flowing%20shapes%2C%20intense%20dramatic%20lighting%2C%20clean%20composition%20with%20atmospheric%20background%2C%20no%20text&width=600&height=800&seq=card-05&orientation=portrait',
    desc: '猎人们以特殊武器猎杀失控的触手怪物，守护人类最后的防线。',
  },
  {
    title: '星海迷踪',
    category: '太空歌剧',
    status: '连载中',
    chapters: '更新至 148 话',
    image: 'https://readdy.ai/api/search-image?query=Space%20opera%20manga%20cover%2C%20cosmic%20horror%20with%20organic%20tentacle%20forms%20in%20deep%20space%2C%20dark%20nebula%20colors%20with%20crimson%20accents%2C%20atmospheric%20and%20cinematic%2C%20clean%20composition%2C%20no%20text&width=600&height=800&seq=card-06&orientation=portrait',
    desc: '星际探险队在未知星域遭遇神秘触手文明，一场跨越星系的史诗展开。',
  },
];

export default function CardsSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.15);

  return (
    <section id="cards" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/60 border border-primary-200/50 mb-4">
            <i className="ri-fire-line text-primary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">实时热门 · 每日精选</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门推荐
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            每日精选触手题材热门漫画，发现你的下一部挚爱作品
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cards.map((card, idx) => (
            <CardItem key={card.title} card={card} idx={idx} />
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#index"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多作品
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

function CardItem({ card, idx }: { card: typeof cards[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.08);

  return (
    <a
      ref={ref}
      href="#cards"
      className={`group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      }`}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={card.image}
          alt={card.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {card.hot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded whitespace-nowrap">
            HOT
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <span className="text-white/80 text-xs">{card.chapters}</span>
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors"></div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {card.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
          <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {card.category}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{card.status}</span>
        </div>
        <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{card.desc}</p>
      </div>
    </a>
  );
}